import { cva, type VariantProps } from "../../lib";

export const navHeaderContainerVariants = cva(
  // Figma's App Bar (3408:11043, 280:62652; Ardhi's DQ7 (b) answer,
  // 2026-11-03): `padding-md` 12 above and below a row at least 40 tall (the
  // back button's and the right slot's boxes), so 64, and `padding-sm` 8 on
  // the right and between the parts. Phone values at every width: the bar
  // doesn't step up from 768
  "gap-spacing-sm py-spacing-md pr-spacing-sm relative flex w-full flex-row items-center",
  {
    variants: {
      variant: {
        brand: "bg-luce-brand-static rounded-b-radius-xl",
        white: "bg-luce-neutral-background-default",
        transparent: "bg-transparent",
      },
      // `padding-lg` 16 before the title, `padding-sm` 8 before a back button
      back: {
        true: "pl-spacing-sm",
        false: "pl-spacing-lg",
      },
    },
    defaultVariants: {
      variant: "brand",
      back: false,
    },
  },
);

export type NavHeaderContainerVariantsProps = VariantProps<typeof navHeaderContainerVariants>;
